{
  "$id": "wealthlane://forms/transfer-and-allocate/rules",
  "validations": [
    {
      "id": "name-required",
      "fields": ["name"],
      "rules": [{ "type": "required", "message": "Name is required." }]
    },
    {
      "id": "description-required",
      "fields": ["description"],
      "rules": [{ "type": "required", "message": "Description is required." }]
    }
  ]
}
